import { Box, Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";

import CustomAvatar from "../../CustomAvatar";

const LoadingCommentGptCard = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          backgroundColor: theme.palette.white.main,
          fontSize: "10px",
          margin: "0px 16px 0px 18px",
        }}
      >
        <Box
          sx={{ display: "flex", mb: "38px", mr: "16px", alignItems: "end" }}
        >
          <Box width={"48px"} />
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "180px",
          }}
        >
          <Skeleton
            sx={{
              width: "85%",
              height: "135%",
              borderRadius: "16px 16px 16px 8px",
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          backgroundColor: theme.palette.white.main,
          fontSize: "10px",
          margin: "0px 16px 0px 18px",
        }}
      >
        <Box
          sx={{ display: "flex", mb: "38px", mr: "16px", alignItems: "end" }}
        >
          <CustomAvatar size={"48px"} />
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "180px",
          }}
        >
          <Skeleton
            sx={{
              width: "85%",
              height: "100%",
              borderRadius: "16px 16px 16px 8px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingCommentGptCard;
